import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import ApiError from "lib/ApiError";
import { sendSupplierRequestToPullLogic } from "constants/reactQueryKey";
import { AnfragenManagerClient, post } from "lib/httpService";
import { LeadType } from "types/leadType";
import { Product } from "types/product";

export interface RegistrationRequest {
    productId: Product;
    requestNumber: string;
    supplierId: string;
    contactName: string;
    supplierPhoneNumber: string;
    supplierEmailAddress: string;
    companyName: string;
    leadType: LeadType;
}

export const useSendSendRegistrationRequestToHunterPullLogic = (
    options: UseMutationOptions<
        void,
        ApiError,
        RegistrationRequest,
        unknown
    > = {}
) => {
    return useMutation<void, ApiError, RegistrationRequest>({
        mutationKey: [sendSupplierRequestToPullLogic],
        mutationFn: async (data) =>
            post<void>(
                "/lead/SendRegistrationRequestToHunterPullLogicAsync",
                data,
                AnfragenManagerClient
            ),
        ...options
    });
};
